export default function WholesaleHero() {
  return (
    <section id="wholesale" className="relative w-full h-[78vh] min-h-[560px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={`${import.meta.env.BASE_URL}localized/editorial-drum-01.jpg`}
          alt="A twelve-kilo drum roaster at work in the roastery"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/60 via-primary-950/45 to-primary-950/75"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 md:px-10">
        <div className="w-full max-w-4xl reveal">
          <div className="inline-flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-accent-300"></span>
            <span className="text-xs md:text-sm tracking-[0.35em] uppercase text-accent-200">
              Wholesale · For Cafes &amp; Trade
            </span>
            <span className="h-px w-10 bg-accent-300"></span>
          </div>

          <h1 className="font-heading text-background-50 text-4xl md:text-6xl lg:text-[4.5rem] leading-[1.08] mb-8">
            Coffee for your counter,<br />
            <em className="text-accent-300 font-medium">roasted to order.</em>
          </h1>

          <p className="text-background-100/90 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-10">
            We roast for cafes, restaurants and offices in bulk — the same small batches, off the same
            drums, as the bags on our own shelf. Tell us how you pour and we will build the order around it.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#wholesale-enquiry"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-accent-500 text-primary-950 text-sm tracking-wide font-medium hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span>Start an Enquiry</span>
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="#how-it-works"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-background-50/60 text-background-50 text-sm tracking-wide font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-route-line w-4 h-4 flex items-center justify-center"></i>
              <span>How It Works</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
